import { render } from "./HeaderSidebarNew.vue?vue&type=template&id=d3298a44&scoped=true"
import script from "./HeaderSidebarNew.vue?vue&type=script&lang=js"
export * from "./HeaderSidebarNew.vue?vue&type=script&lang=js"

import "./HeaderSidebarNew.vue?vue&type=style&index=0&id=d3298a44&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src840913126/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3298a44"]])

export default __exports__